import Image from 'next/image'
import { useState } from 'react'
import { composeClasses } from '@wiggot/web-components'
import { CustomDropdown } from './CustomDropdown'

interface IOption {
  [key: string]: string
}

interface IDropdown {
  filter: string | undefined
  setFilters: (o: any) => void
  options: IOption[]
  isLoading?: boolean
  placeholder: string
  onClose: (cb: () => void) => void
  onConfirm: (cb: () => void) => void
  operationType: string[]
}

export const Opportunities = ({
  filter,
  setFilters = () => null,
  options = [],
  isLoading = false,
  placeholder,
  onClose,
  onConfirm,
  operationType
}: IDropdown) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClearFilters = () => {
    setIsOpen(false)
  }

  const handleOnClose = () => {
    setIsOpen(false)
  }

  const handleSelect = (id: string) => {
    if (id === filter) {
      setFilters(undefined)
    } else {
      setFilters(id)
      setIsOpen(false)
    }
  }

  const renderOptions = () => {
    const operation = (operationType && operationType[0]) || ''
    const operationValidated = operation === 'PRESALE' ? 'SALE' : operation
    return options
      ?.filter((op) => operationValidated === op?.type)
      ?.map(
        ({ title, description, id, badge, colorClasses, color }: IOption) => {
          return (
            <div
              key={id}
              onClick={() => handleSelect(id)}
              className={composeClasses(
                'w-full border rounded-md min-h-[98px] flex flex-col p-2 gap-2 cursor-pointer hover:!text-[#fff] hover:transition-all',
                colorClasses,
                filter === id ? `${color} !text-[#fff]` : `${color}-01`
              )}
            >
              <div className="flex gap-2">
                {badge && <Image src={badge} alt={id} />}
                <p className="text-sm text-dark font-semibold">{title}</p>
              </div>
              <span className="text-xs">{description}</span>
            </div>
          )
        }
      )
  }

  return (
    <CustomDropdown
      isOpen={isOpen && !isLoading}
      setIsOpen={isLoading ? () => null : setIsOpen}
      placeholder={placeholder}
      menuTitle={placeholder}
      renderOptions={renderOptions()}
      onReset={onClearFilters}
      withSearch={false}
      searchVal=""
      setSearchVal={() => null}
      activeFilters={filter ? 1 : 0}
      onConfirm={() => onConfirm(handleOnClose)}
      onClose={() => onClose(handleOnClose)}
      withoutFooter={true}
      dropdownClassName="max-h-fit"
      optionsContainerClassNames="max-h-[350px]"
      pillButtonClassName="w-full justify-between"
      pillButtonContainerClassName="w-full"
    />
  )
}
